import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserDemographic } from 'src/app/models/user_demographic.model';
import { UserService } from 'src/app/services/user_service.service';
import { MatFormField, MatLabel } from "@angular/material/select";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatDatepickerToggle, MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [MatFormField, MatLabel, MatProgressBar, MatDatepickerToggle, MatDatepicker, CommonModule, ReactiveFormsModule, MatDatepickerModule],
})
export class ProfileComponent implements OnInit {
    user?: UserDemographic;
    loading = false;
    saving = false;
    submitted = false;

    profileForm = new FormGroup({
        firstName: new FormControl(),
        lastName: new FormControl(),
        dateOfBirth: new FormControl(),
        emailAddress: new FormControl(),
        address: new FormControl(),
        city: new FormControl(),
        state: new FormControl(),
        zipCode: new FormControl(),
        primaryPhoneNumber: new FormControl(),
        secondaryPhoneNumber: new FormControl(),
    });

    constructor(
        private userService: UserService,
        private formBuilder: FormBuilder,
        private router: Router,
    ) { }

    get formControls(): { [p: string]: AbstractControl } {
        return this.profileForm.controls;
    }

    get formValues(): any {
        return this.profileForm.value;
    }

    ngOnInit(): void {
        this.loading = true;
        this.userService.get([], new Map()).subscribe(x => {
            this.user = x.user;
            this.profileForm = this.formBuilder.group({
                firstName: [this?.user?.firstName, Validators.required],
                lastName: [this?.user?.lastName, Validators.required],
                dateOfBirth: [this?.user?.dateOfBirth, Validators.required],
                emailAddress: [this?.user?.emailAddress, Validators.required],
                address: [this?.user?.address, Validators.required],
                city: [this?.user?.city, Validators.required],
                state: [this?.user?.state, Validators.required],
                zipCode: [this?.user?.zipCode, Validators.required],
                primaryPhoneNumber: [this?.user?.primaryPhoneNumber, Validators.required],
                secondaryPhoneNumber: [this?.user?.secondaryPhoneNumber],
            });
            this.loading = false;
        });
    }

    onSubmit(): void {
        if (this.user?.userId != null) {
            this.saving = true;

            const userId = this.user.userId;
            const firstName = this.formControls.firstName.value;
            const lastName = this.formControls.lastName.value;
            const dateOfBirth = this.formControls.dateOfBirth.value;
            const emailAddress = this.formControls.emailAddress.value;
            const address = this.formControls.address.value;
            const city = this.formControls.city.value;
            const state = this.formControls.state.value;
            const zipCode = this.formControls.zipCode.value;
            const primaryPhoneNumber = this.formControls.primaryPhoneNumber.value;
            const secondaryPhoneNumber = this.formControls.secondaryPhoneNumber.value;

            this.userService
                .put([], {
                    userId,
                    firstName,
                    lastName,
                    dateOfBirth,
                    emailAddress,
                    address,
                    city,
                    state,
                    zipCode,
                    primaryPhoneNumber,
                    secondaryPhoneNumber
                }).subscribe(_ => { this.saving = false; }
                );
        }
    }
}
